import React, { Component } from 'react';;
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocDateTimeEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="dt" className="heading-1">DateTime</h3>
                    <div className="description">
                        The extraction of a datetime entity is based upon the presence of date and/or
                        time components. The pattern attempts to match various written forms of date
                        and time with the exception that a date minimally has temporal value for a
                        month and a day of the month and time minimally has a temporal value for an
                        hour and minutes of an hour.
                    </div>

                    <h4 className="heading-3">Locale Neutral Date</h4>
                    <code className="code-snippet">
                        <span className="line">MMDDYYYY (10-22-2013, 10/22/13, Oct 22 2013) </span>
                        <span className="line">YYYYMMDD (2013-10-22, 13/10/22, 2013 Oct 22)</span>
                        <span className="line">DDMMYYYY (23 Oct 2013, 23-10-2013) </span>
                    </code>

                    <h4 className="heading-3">English Written Date</h4>
                    <code className="code-snippet">
                        <span className="line">Complete (Oct. 22nd, 2013, October 22nd, 2013, Twenty-Second of October, 2013, 22nd of October 2013)</span>
                        <span className="line">Partial (9 July)</span>
                    </code>

                    <div className="description">
                        Other partial date matches may be extracted by the datetime range regular
                        expression pattern.
                    </div>

                    <h4 className="heading-3">Time</h4>
                    <code className="code-snippet">
                        <span className="line">Standard Time (11:11, 11:11 PM , 23:59:59, 23:59:59.00Z) </span>
                        <span className="line">Military Time (1800 hours, 0500 hrs, 0930GMT)</span>
                        <span className="line">OCLOCK Time (5 o'clock, 10 'clock, 3 PM) </span>
                    </code>

                    <h4 className="heading-3">Non English</h4>
                    <code className="code-snippet">
                        <span className="line">Complete textual date (28 februari 2018) </span>
                    </code>

                    <h4 className="heading-3">Relative</h4>
                    <code className="code-snippet">
                        <span className="line">Simple (last March 11th) </span>
                    </code>

                    <div className="description">
                        Relative is only applicable if publishDate is provided in the request.
                    </div>

                    <br/>

                    <div className="description">
                        Matches with complete date and/or time components are expressed in ISO8601 form
                        to keep locale neutral. An extracted datetime entity will be represented by the
                        following attributes:
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">dayOfMonth</td>
                            <td className="meaning">Represents the temporal value for the day of the month</td>
                            <td className="type">Number</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">The value will be represented as a numeric digit</td>
                        </tr>
                        <tr>
                            <td className="attribute">monthOfYear</td>
                            <td className="meaning">Represents the temporal value for the month of the year</td>
                            <td className="type">Number</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">The value will be represented as a numeric digit</td>
                        </tr>
                        <tr>
                            <td className="attribute">year</td>
                            <td className="meaning">Represents the temporal value for year</td>
                            <td className="type">Number</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">The value will be represented as a numeric digit</td>
                        </tr>
                        <tr>
                            <td className="attribute">hour</td>
                            <td className="meaning">Represents the temporal value for the hour of the day</td>
                            <td className="type">Number</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">The value will be represented as a numeric digit</td>
                        </tr>
                        <tr>
                            <td className="attribute">minute</td>
                            <td className="meaning">Represents the temporal value for the minute of the hour</td>
                            <td className="type">Number</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">The value will be represented as a numeric digit</td>
                        </tr>
                        <tr>
                            <td className="attribute">second</td>
                            <td className="meaning">Represents the temporal value for the second of the minute</td>
                            <td className="type">Number</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">The value will be represented as a numeric digit</td>
                        </tr>
                        <tr>
                            <td className="attribute">timeZone</td>
                            <td className="meaning">Represents the time zone</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"> The full name associated with the extracted time zone</td>
                        </tr>
                        <tr>
                            <td className="attribute">estimated</td>
                            <td className="meaning">A boolean flag indicating if the datetime value is estimated</td>
                            <td className="type">Boolean</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"><i>true</i> if the datetime value is estimated using <i>publishDate</i>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Examples</h4>

                    <div className="example-content">Time of Day: 10:10 am </div>
                    <HttpRunner example="date1" 
                        query="enrich" 
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DATETIME1) : null}
                    />
                    <br/>
                    <div className="example-content">Calendar Date: Wednesday, October 4, 2006 02:00 PM EDT </div>
                    <HttpRunner example="date2" 
                        query="enrich" 
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DATETIME2) : null}
                    />
                    <br/>
                    <div className="example-content">Relative: The meeting will be next Tuesday</div>
                    <HttpRunner example="date3" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_DATETIME3) : null}
                    />
                </div>
            </div>
        );
    }
}

export default DocDateTimeEntity;